import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {useRouter, useRoute} from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'Result',
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const route = useRoute();

// const type = ref(route.query.type == 'single' ? '采购' : '供应');

const type = ref({
    single: {
        title: '采购',
        tips: '报价',
    },
    supply: {
        title: '供应',
        tips: '浏览',
    },
    process: {
        title: '处理',
        tips: '报价',
    },
});
//@ts-ignore
const title = ref(`发布${type.value[route.query.type as string]?.title || '供应'}成功`);
//@ts-ignore
const tips = ref(type.value[route.query.type as string]?.tips || `报价`);

const __returned__ = { router, route, type, title, tips, ref, useRouter, useRoute }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})